import axios from 'axios';
import {useState, useEffect} from 'react';

import {URLS} from '../config';
import {AcademyType} from '../types/AcademyType';

export const useGetAcademy = () => {
  const [academy, setAcademy] = useState<AcademyType[]>([]);
  const [academyLoading, setAcademyLoading] = useState<boolean>(false);

  const getAcademy = async () => {
    setAcademyLoading(true);

    try {
      const response = await axios.get(URLS.GET_ACADEMY_LOCAL);
      setAcademy(response.data.academy);
    } catch (error) {
      console.error(error);
    } finally {
      setAcademyLoading(false);
    }
  };

  useEffect(() => {
    getAcademy();
  }, []);

  return {academyLoading, academy};
};
